import {radialProgressiveBlur} from '@remotion/effects/radial-progressive-blur';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	HtmlInCanvas,
	interpolate,
	useCurrentFrame,
} from 'remotion';

export const CloseUp7Preview = () => {
	const frame = useCurrentFrame();
	const captureFrame = frame + 355;

	return (
		<HtmlInCanvas
			width={3320}
			height={2310}
			effects={[
				radialProgressiveBlur({
					center: [0.28, 0.253],
					endBlur: 10,
					height: 0.36,
					width: 0.201,
					rotation: -17.8,
				}),
			]}
		>
			<AbsoluteFill
				name="Canvas Capture"
				style={{
					width: 3320,
					height: 2310,
					translate: '-1312.7px -363.4px',
					rotate: '0.974685 0.089312 -0.204969 52.344171deg',
					scale: 1.51,
				}}
				from={-355}
			>
				<Video
					src="https://remotion.media/studio-close-ups/studio-pattern-effect-editing.mp4"
					style={{
						position: 'absolute',
					}}
				/>
				<MacOSCursor
					cursor={interpolate(
						captureFrame,
						[19, 70, 71, 171, 204, 209, 243, 387, 417, 422, 567, 569],
						[
							'auto',
							'ew-resize',
							'auto',
							'default',
							'auto',
							'default',
							'auto',
							'default',
							'auto',
							'default',
							'text',
							'auto',
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					)}
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: interpolate(
							captureFrame,
							[0, 134, 141, 249, 254, 284, 290, 366, 375, 461, 470],
							[3.5, 3.15, 3.5, 3.15, 3.5, 3.15, 3.5, 3.15, 3.5, 3.15, 3.5],
							{
								easing: Easing.step1,
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
						translate: interpolate(
							captureFrame,
							[
								19, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77,
								78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93,
								94, 95, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178,
								179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191,
								192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204,
								205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217,
								218, 220, 221, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247,
								248, 249, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272,
								273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 293, 294,
								295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307,
								308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320,
								321, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396,
								397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409,
								410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422,
								423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435,
								562, 563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573, 672,
								673, 693, 694,
							],
							[
								'859.427734375px 706.904296875px',
								'859.427734375px 706.904296875px',
								'2505.056640625px 1019.279296875px',
								'2505.056640625px 1019.279296875px',
								'2505.056640625px 1005.224609375px',
								'2495.486328125px 970.6484375px',
								'2469.9609375px 934.5546875px',
								'2432.623046875px 888.986328125px',
								'2388.873046875px 840.861328125px',
								'2307.033203125px 767.771484375px',
								'2224.673828125px 721.177734375px',
								'2181.6484375px 693.615234375px',
								'2138.623046875px 666.052734375px',
								'2113.80859375px 650.2890625px',
								'2099.75390625px 640.91015625px',
								'2087.517578125px 628.673828125px',
								'2080.134765625px 621.291015625px',
								'2064.7265625px 605.8828125px',
								'2051.4921875px 590.310546875px',
								'2040.7734375px 581.9296875px',
								'2029.056640625px 570.212890625px',
								'2021.673828125px 564.67578125px',
								'2010.955078125px 558.6328125px',
								'2000.236328125px 552.09765625px',
								'1992.853515625px 546.560546875px',
								'1982.134765625px 538.1796875px',
								'1971.416015625px 529.798828125px',
								'1964.033203125px 522.416015625px',
								'1956.650390625px 516.87890625px',
								'1951.11328125px 511.341796875px',
								'1947.927734375px 506.310546875px',
								'1945.248046875px 503.630859375px',
								'1943.908203125px 502.291015625px',
								'1942.80078125px 500.951171875px',
								'1942.80078125px 500.951171875px',
								'1943.634765625px 500.951171875px',
								'1954.326171875px 507.458984375px',
								'1969.87109375px 520.666015625px',
								'1991.814453125px 539.24609375px',
								'2008.876953125px 556.30859375px',
								'2019.568359375px 564.662109375px',
								'2025.078125px 572.017578125px',
								'2030.587890625px 579.373046875px',
								'2034.251953125px 586.728515625px',
								'2037.916015625px 595.068359375px',
								'2041.580078125px 602.423828125px',
								'2046.255859375px 616.451171875px',
								'2048.59375px 623.46484375px',
								'2055.1015625px 641.169921875px',
								'2059.77734375px 655.197265625px',
								'2062.115234375px 669.224609375px',
								'2067.296875px 687.61328125px',
								'2074.81640625px 713.015625px',
								'2077.66015625px 724.390625px',
								'2082.3359375px 745.431640625px',
								'2087.01171875px 759.458984375px',
								'2089.349609375px 773.486328125px',
								'2091.6875px 787.513671875px',
								'2094.025390625px 801.541015625px',
								'2096.36328125px 815.568359375px',
								'2101.0390625px 829.595703125px',
								'2101.0390625px 840.287109375px',
								'2102.87109375px 847.642578125px',
								'2104.703125px 854.998046875px',
								'2106.53515625px 862.353515625px',
								'2106.53515625px 869.708984375px',
								'2108.3671875px 877.064453125px',
								'2110.19921875px 884.419921875px',
								'2110.19921875px 891.775390625px',
								'2111.525390625px 896.779296875px',
								'2113.357421875px 904.134765625px',
								'2113.357421875px 909.138671875px',
								'2117.021484375px 917.8203125px',
								'2117.021484375px 922.82421875px',
								'2117.021484375px 927.828125px',
								'2118.853515625px 935.18359375px',
								'2120.685546875px 942.5390625px',
								'2120.685546875px 956.56640625px',
								'2122.517578125px 963.921875px',
								'2122.517578125px 974.61328125px',
								'2124.349609375px 981.96875px',
								'2124.349609375px 984.62109375px',
								'2124.349609375px 989.625px',
								'2124.349609375px 992.27734375px',
								'2124.349609375px 993.603515625px',
								'2124.349609375px 993.603515625px',
								'2125.251953125px 993.603515625px',
								'2125.251953125px 993.603515625px',
								'2117.650390625px 993.603515625px',
								'2047.91015625px 993.603515625px',
								'2008.794921875px 1003.37890625px',
								'1960.150390625px 1019.580078125px',
								'1870.53125px 1049.69921875px',
								'1805.671875px 1082.361328125px',
								'1758.6953125px 1109.158203125px',
								'1743.615234375px 1115.6796875px',
								'1736.232421875px 1119.34375px',
								'1734.892578125px 1120.669921875px',
								'1734.318359375px 1120.669921875px',
								'1734.318359375px 1120.669921875px',
								'1739.951171875px 1120.669921875px',
								'1827.68359375px 1120.669921875px',
								'1957.78515625px 1120.669921875px',
								'2162.26171875px 1120.669921875px',
								'2470.904296875px 1120.669921875px',
								'2631.78125px 1120.669921875px',
								'2812.7421875px 1120.669921875px',
								'2967.20703125px 1127.62890625px',
								'3097.30859375px 1145.908203125px',
								'3097.30859375px 1145.908203125px',
								'3176.345703125px 1170.107421875px',
								'3210.89453125px 1187.375px',
								'3225.947265625px 1194.89453125px',
								'3231.45703125px 1200.404296875px',
								'3236.4609375px 1203.5625px',
								'3239.619140625px 1208.56640625px',
								'3242.77734375px 1214.896484375px',
								'3244.103515625px 1219.900390625px',
								'3245.4296875px 1224.904296875px',
								'3245.4296875px 1227.556640625px',
								'3246.755859375px 1228.8828125px',
								'3246.755859375px 1228.8828125px',
								'3234.4921875px 1228.8828125px',
								'3164.751953125px 1228.8828125px',
								'3057.9609375px 1201.005859375px',
								'2903.46875px 1154.31640625px',
								'2771.220703125px 1122.59765625px',
								'2616.728515625px 1075.908203125px',
								'2498.248046875px 1028.521484375px',
								'2400.958984375px 996.078125px',
								'2361.84375px 976.513671875px',
								'2261.478515625px 935.59375px',
								'2200.228515625px 909.34375px',
								'2163.615234375px 891.54296875px',
								'2127.521484375px 866.017578125px',
								'2102.201171875px 850.759765625px',
								'2082.267578125px 836.513671875px',
								'2066.6953125px 823.279296875px',
								'2049.60546875px 806.189453125px',
								'2027.634765625px 787.58203125px',
								'2000.783203125px 760.73046875px',
								'1977.294921875px 733.87890625px',
								'1934.529296875px 691.11328125px',
								'1919.77734375px 667.310546875px',
								'1899.65234375px 637.109375px',
								'1882.876953125px 603.55859375px',
								'1867.11328125px 575.39453125px',
								'1861.904296875px 556.978515625px',
								'1860.05859375px 549.595703125px',
								'1858.71875px 545.576171875px',
								'1858.71875px 545.576171875px',
								'1858.71875px 551.796875px',
								'1858.71875px 565.82421875px',
								'1861.056640625px 584.212890625px',
								'1878.32421875px 618.76171875px',
								'1890.7109375px 639.1875px',
								'1906.447265625px 667.32421875px',
								'1916.810546875px 685.712890625px',
								'1929.703125px 710.5px',
								'1939.0546875px 724.52734375px',
								'1944.236328125px 742.916015625px',
								'1949.923828125px 765.666015625px',
								'1958.455078125px 799.791015625px',
								'1963.63671875px 818.1796875px',
								'1965.974609375px 832.20703125px',
								'1970.14453125px 842.8984375px',
								'1970.14453125px 846.576171875px',
								'1973.80859375px 853.931640625px',
								'1975.640625px 861.287109375px',
								'1977.47265625px 869.96875px',
								'1979.3046875px 874.97265625px',
								'1982.462890625px 879.9765625px',
								'1984.294921875px 884.98046875px',
								'1986.126953125px 889.984375px',
								'1987.453125px 891.310546875px',
								'1989.28515625px 898.666015625px',
								'1990.611328125px 903.669921875px',
								'1994.275390625px 911.025390625px',
								'1996.107421875px 918.380859375px',
								'1999.771484375px 925.736328125px',
								'2003.435546875px 936.76953125px',
								'2005.267578125px 944.125px',
								'2005.267578125px 949.12890625px',
								'2007.099609375px 956.484375px',
								'2008.42578125px 961.48828125px',
								'2009.751953125px 966.4921875px',
								'2009.751953125px 971.49609375px',
								'2011.078125px 976.5px',
								'2011.078125px 985.181640625px',
								'2012.404296875px 986.5078125px',
								'2012.404296875px 995.189453125px',
								'2013.73046875px 1000.193359375px',
								'2013.73046875px 1002.845703125px',
								'2013.73046875px 1005.498046875px',
								'2013.73046875px 1008.150390625px',
								'2013.73046875px 1010.802734375px',
								'2013.73046875px 1013.455078125px',
								'2013.73046875px 1016.107421875px',
								'2013.73046875px 1017.43359375px',
								'2013.73046875px 1018.513671875px',
								'2013.73046875px 1019.51171875px',
								'2013.73046875px 1019.51171875px',
								'2013.73046875px 1016.4765625px',
								'2019.41796875px 998.060546875px',
								'2056.728515625px 956.8671875px',
								'2189.072265625px 845.38671875px',
								'2285.28125px 781.23828125px',
								'2396.37890625px 704.306640625px',
								'2693.291015625px 506.693359375px',
								'3017.998046875px 313.87890625px',
								'3403.61328125px 84.916015625px',
								'3486px 32.470703125px',
								'3550.421875px 0.24609375px',
								'3550.421875px 0.24609375px',
								'2944.005859375px 195.576171875px',
								'2944.005859375px 195.576171875px',
								'639.720703125px 720.5078125px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</HtmlInCanvas>
	);
};

export const CloseUp7 = () => {
	return (
		<Composition
			id="AddEffect"
			component={CloseUp7Preview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={90}
		/>
	);
};
